import { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { setMetaTags } from '@/seo/seo'; // ⚠️ ajustez le chemin selon l'emplacement réel de metaTags.ts

const META_BY_LANG = {
  en: {
    title: 'AcquizGroup - M&A Ecosystem Platform',
    description:
      'The trusted M&A marketplace connecting buyers, sellers, brokers, lenders, consultants, and experts. Discover, evaluate, and close business acquisitions with confidence.',
  },
  fr: {
    title: 'AcquizGroup - Plateforme de mise en relation M&A',
    description:
      "La plateforme de confiance qui connecte acheteurs, vendeurs, courtiers, prêteurs, consultants et experts en M&A. Découvrez, évaluez et concluez des acquisitions d'entreprises en toute confiance.",
  },
} as const;

/**
 * Met à jour dynamiquement les balises meta (title, description, og:*, twitter:*)
 * selon la langue active de l'application. Le fallback statique dans index.html
 * reste en anglais pour les crawlers qui n'exécutent pas le JS.
 */
export function useDocumentMeta() {
  const { language } = useLanguage();

  useEffect(() => {
    const meta = META_BY_LANG[language === 'fr' ? 'fr' : 'en'];
    setMetaTags({
      title: meta.title,
      description: meta.description,
      url: 'https://www.acquizgroup.com',
      image: 'https://www.acquizgroup.com/noBgColor.png',
      locale: language === 'fr' ? 'fr_CA' : 'en_US',
    });
  }, [language]);
}